import { Routes } from '@angular/router';

export const CHILDREN_ROUTES: Routes = [
    {
        path: 'home',
        loadChildren: async () => (await import('./domains/home/home.routes')).HOME_ROUTES,
        data: { icon: 'pi pi-home', text: 'Início', skip: true }
    },
    {
        path: 'admin',
        loadChildren: async () => (await import('./domains/admin/admin.routes')).ADMIN_ROUTES,
        data: {
            icon: 'pi pi-building', text: 'Administração', skip: false,
            menu: [
                { path: 'holidays', icon: 'pi pi-calendar-plus', text: 'Cadastro de feriados' },
                { path: 'users', icon: 'pi pi-user', text: 'Cadastro de usuários' },
                { path: 'vehicles', icon: 'pi pi-car', text: 'Cadastro de veículos' },
                { path: 'plans', icon: 'pi pi-book', text: 'Cadastro de planos' },
                { path: 'positions', icon: 'pi pi-briefcase', text: 'Cadastro de cargos' },
                { path: 'agencies', icon: 'pi pi-building', text: 'Cadastro de agências' },
                { path: 'customers', icon: 'pi pi-users', text: 'Cadastro de clientes' },
                { path: 'goals', icon: 'pi pi-flag', text: 'Cadastro de metas' },
                { path: 'sections', icon: 'pi pi-th-large', text: 'Cadastro de seção' },
                { path: 'candidates', icon: 'pi pi-id-card', text: 'Gestão de candidatos' }
            ]
        }
    },
    {
        path: 'finance',
        loadChildren: async () => (await import('./domains/finance/finance.routes')).FINANCE_ROUTES,
        data: {
            icon: 'pi pi-wallet', text: 'Financeiro', skip: false,
            menu: [
                { path: 'accounts-payable', icon: 'pi pi-arrow-circle-up', text: 'Contas a pagar' },
                { path: 'accounts-receivable', icon: 'pi pi-arrow-circle-down', text: 'Contas a receber' },
                { path: 'cash-flow', icon: 'pi pi-chart-line', text: 'Fluxo de caixa' },
                { path: 'oesp-data', icon: 'pi pi-database', text: 'Dados OESP' }
            ]
        }
    },
    {
        path: 'customer-care',
        loadChildren: async () => (await import('./domains/customer-care/customer-care.routes')).CUSTOMER_CARE_ROUTES,
        data: {
            icon: 'pi pi-users', text: 'Atendimento', skip: false,
            menu: [
                { path: 'new-calculator', icon: 'pi pi-calculator', text: 'Nova calculadora' },
                { path: 'new-order', icon: 'pi pi-shopping-cart', text: 'Novo Pedido' }
            ]
        }
    },
    {
        path: 'manufacturing',
        loadChildren: async () => (await import('./domains/manufacturing/manufacturing.routes')).MANUFACTURING_ROUTES,
        data: {
            icon: 'pi pi-box', text: 'Produção', skip: false,
            menu: [
                { path: 'generate-art', icon: 'pi pi-image', text: 'Gerar arte' },
                { path: 'create-layout', icon: 'pi pi-objects-column', text: 'Criar diagramação' }
            ]
        }
    },
    {
        path: 'reports',
        loadChildren: async () => (await import('./domains/reports/reports.routes')).REPORTS_ROUTES,
        data: {
            icon: 'pi pi-chart-bar', text: 'Relatórios', skip: false,
            menu: [
                { path: 'daily-sales', icon: 'pi pi-chart-bar', text: 'Vendas diárias' },
                { path: 'scorecard', icon: 'pi pi-star', text: 'Painel de desempenho' }
            ]
        }
    }
]